<section class="documentation" *ngIf="documentationData">
    <h1 class="documentation__main-title">
        {{ documentationData.TITLE }}
    </h1>

    <div class="documentation__sections">
        <article class="documentation__section"
            *ngFor="let section of documentationData.SECTIONS; trackBy: trackBySection">
            <!-- <h2 class="documentation__section-title" [innerHTML]="section.TITLE"></h2> -->
            <h2 class="documentation__item-text" [innerHTML]="documentationData.ONLY"></h2>
            <ul class="documentation__list">
                <li class="documentation__item" *ngFor="let item of section.ITEMS; trackBy: trackByItem">
                    <span class="documentation__item-text" [innerHTML]="item.TEXT"></span>

                    <ul class="documentation__sublist" *ngIf="item.SUBITEMS?.length">
                        <li class="documentation__subitem"
                            *ngFor="let subitem of item.SUBITEMS; trackBy: trackBySubitem">
                            <span class="documentation__subitem-text" [innerHTML]="subitem"></span>
                        </li>
                    </ul>
                </li>
            </ul>
            <h2 class="documentation__item-text" [innerHTML]="section.TEXT"></h2>
            <p class="documentation__note" [innerHTML]="section.NOTE"></p>
        </article>
    </div>
</section>